import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../utils/style';

export const defaultContext = makeDefaultStylingContext();

export const imageSizes = {
  [HD]: {
    width: 48,
    height: 48,
  },
  [FULL_HD]: {
    width: 56,
    height: 56,
  },
};

export const getImageRadius = screenSize => Math.round(imageSizes[screenSize].width / 2);

export const getImageSize = screenSize => imageSizes[screenSize];

export const getInitialStyle = (context = defaultContext) => ({
  w: imageSizes[context.screenSize].width,
  h: imageSizes[context.screenSize].height,
  shader: {
    radius: getImageRadius(context.screenSize),
  },
});
